(function initFlooringCalculator() {
  const calculatorBlock = document.querySelector('[data-block-handle="calculator"]');
  const root = calculatorBlock?.querySelector(".calculator-div");
  if (!root) return;

  const totalAreaRadio = root.querySelector("#total-area");
  const widthLengthRadio = root.querySelector("#Width-Length");
  const areaInputContainer = root.querySelector(".input-container-area");
  const lengthWidthInputsContainer = root.querySelector(".length-width-inputs");
  const widthInput = root.querySelector("#calculator-width");
  const lengthInput = root.querySelector("#calculator-length");
  const areaInput = root.querySelector("#calculator-area");
  const wastageCheckbox = root.querySelector("#add-wastage");
  const qtyRequiredEl = root.querySelector("#qty-required");
  const areaRequiredValueEl = root.querySelector("#area-required-value");
  const priceDisplayEl = root.querySelector("#total-price-display");

  if (!totalAreaRadio || !widthLengthRadio || !areaInputContainer || !lengthWidthInputsContainer) {
    return;
  }

  const UNIT_LABELS = {
    meters: { width: "m", length: "m", area: "m²" },
    cm: { width: "cm", length: "cm", area: "cm²" },
    feet: { width: "ft", length: "ft", area: "ft²" },
  };

  const cartUpdatedEvent = window.EVENTS?.cartUpdated || "cart:updated";

  let currentUnit = "meters";
  let quantitySetupTimeout = null;
  let observer = null;

  function getCoverage() {
    return parseFloat(root.dataset.metafieldCoverage) || 1;
  }

  function getPerPackPrice() {
    return parseFloat(root.dataset.perPackPrice) || 0;
  }

  function getQuantityInput() {
    const sectionId = root.dataset.sectionId;
    if (sectionId) {
      const byId = root.querySelector("#Quantity-" + sectionId);
      if (byId) return byId;
    }
    return root.querySelector('quantity-selector-component input[name="quantity"]');
  }

  function isLengthWidthMode() {
    return widthLengthRadio.checked;
  }

  function convertToMeters(value, unit, isArea = false) {
    if (Number.isNaN(value)) return 0;
    if (unit === "feet") {
      return isArea ? value / 10.764 : value / 3.281;
    }
    if (unit === "cm") {
      // 100 cm = 1 m; 10,000 cm² = 1 m²
      return isArea ? value / 10000 : value / 100;
    }
    return value;
  }

  function updateLabels() {
    const labels = UNIT_LABELS[currentUnit] || UNIT_LABELS.meters;
    const widthLabel = root.querySelector("label[for='calculator-width']");
    const lengthLabel = root.querySelector("label[for='calculator-length']");
    const areaLabel = root.querySelector("label[for='calculator-area']");
    if (widthLabel) widthLabel.textContent = labels.width;
    if (lengthLabel) lengthLabel.textContent = labels.length;
    if (areaLabel) areaLabel.textContent = labels.area;
    if (areaInput) {
      areaInput.placeholder = `Number of ${labels.area} required`;
    }
  }

  function updatePriceDisplay(totalPrice) {
    if (typeof totalPrice !== "number" || Number.isNaN(totalPrice) || !priceDisplayEl) return;
    priceDisplayEl.textContent = `£${totalPrice.toFixed(2)}`;
  }

  function resetCalculatorResults() {
    if (qtyRequiredEl) qtyRequiredEl.textContent = "Total Packs: 0";
    if (areaRequiredValueEl) areaRequiredValueEl.textContent = "0";
    updatePriceDisplay(0);
  }

  function updateQuantitySelector(quantity) {
    const quantityPicker = getQuantityInput();
    if (!quantityPicker) return;

    const min = parseInt(quantityPicker.getAttribute("min"), 10) || 1;
    const n = parseInt(quantity, 10);
    const value = !Number.isFinite(n) || n < min ? min : n;

    quantityPicker.value = String(value);
    quantityPicker.setAttribute("value", String(value));
    quantityPicker.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function applyCalculation(areaInM2) {
    if (!Number.isFinite(areaInM2) || areaInM2 <= 0) {
      resetCalculatorResults();
      return;
    }

    const adjustedArea = wastageCheckbox?.checked ? areaInM2 * 1.1 : areaInM2;
    const areaDisplay = adjustedArea.toFixed(2);
    const packs = Math.ceil(adjustedArea / getCoverage());

    if (qtyRequiredEl) qtyRequiredEl.textContent = `Total Packs: ${packs}`;
    if (areaRequiredValueEl) areaRequiredValueEl.textContent = areaDisplay;

    updateQuantitySelector(packs);
    updatePriceDisplay(packs * getPerPackPrice());
  }

  function calculateFromLengthWidth() {
    const width = parseFloat(widthInput?.value);
    const length = parseFloat(lengthInput?.value);

    if (Number.isNaN(width) || Number.isNaN(length)) {
      resetCalculatorResults();
      return;
    }

    const areaInM2 =
      convertToMeters(width, currentUnit) * convertToMeters(length, currentUnit);
    applyCalculation(areaInM2);
  }

  function calculateFromArea() {
    const area = parseFloat(areaInput?.value);

    if (Number.isNaN(area)) {
      resetCalculatorResults();
      return;
    }

    applyCalculation(convertToMeters(area, currentUnit, true));
  }

  function recalculate() {
    if (isLengthWidthMode()) {
      if (areaInput) areaInput.value = "";
      calculateFromLengthWidth();
      return;
    }

    if (widthInput) widthInput.value = "";
    if (lengthInput) lengthInput.value = "";
    calculateFromArea();
  }

  function onLengthWidthInput() {
    if (areaInput) areaInput.value = "";
    calculateFromLengthWidth();
  }

  function onAreaInput() {
    if (widthInput) widthInput.value = "";
    if (lengthInput) lengthInput.value = "";
    calculateFromArea();
  }

  function toggleInputFields() {
    if (totalAreaRadio.checked) {
      areaInputContainer.classList.remove("hidden");
      lengthWidthInputsContainer.classList.add("hidden");
      lengthWidthInputsContainer.classList.remove("flex", "flex-col", "gap-3", "mt-2");
    } else {
      areaInputContainer.classList.add("hidden");
      lengthWidthInputsContainer.classList.remove("hidden");
      lengthWidthInputsContainer.classList.add("flex", "flex-col", "gap-3", "mt-2");
    }
  }

  function updatePriceFromQuantitySelector() {
    try {
      const quantityPicker = getQuantityInput();
      if (!quantityPicker) return;

      const quantity = parseInt(quantityPicker.value, 10) || 0;
      if (qtyRequiredEl) qtyRequiredEl.textContent = `Total Packs: ${quantity}`;
      if (areaRequiredValueEl) {
        areaRequiredValueEl.textContent = (quantity * getCoverage()).toFixed(2);
      }
      updatePriceDisplay(quantity * getPerPackPrice());
    } catch (error) {
      console.warn("Error updating price from quantity selector:", error);
    }
  }

  function setupQuantitySelectorListeners() {
    const quantityPicker = getQuantityInput();
    if (!quantityPicker || quantityPicker.dataset.flooringQtyBound === "1") return;

    quantityPicker.dataset.flooringQtyBound = "1";
    quantityPicker.addEventListener("input", updatePriceFromQuantitySelector);
    quantityPicker.addEventListener("change", updatePriceFromQuantitySelector);
  }

  function setupTabs() {
    const calculatorHeaderButton = root.querySelector("#calculator-header-button");
    const packsHeaderButton = root.querySelector("#packs-header-button");
    const calculatorPacksQuantity = root.querySelector("#calculator-packs-panel");
    const calculatorCalculationContent = root.querySelector(".calculator-calculation-content");
    const coverageCalculateTab = root.querySelector("#calc-coverage-calculate-tab");
    const coveragePacksTab = root.querySelector("#calc-coverage-packs-tab");

    if (
      !calculatorHeaderButton ||
      !packsHeaderButton ||
      !calculatorPacksQuantity ||
      !calculatorCalculationContent
    ) {
      return;
    }

    function setCoverageVisibilityForTab(isCalculateTab) {
      coverageCalculateTab?.classList.toggle("hidden", !isCalculateTab);
      coveragePacksTab?.classList.toggle("hidden", isCalculateTab);
    }

    function syncPacksTabTotals() {
      getQuantityInput()?.dispatchEvent(new Event("change", { bubbles: true }));
    }

    calculatorPacksQuantity.classList.add("hidden");
    calculatorCalculationContent.classList.remove("hidden");
    setCoverageVisibilityForTab(true);

    calculatorHeaderButton.addEventListener("click", () => {
      calculatorCalculationContent.classList.remove("hidden");
      calculatorPacksQuantity.classList.add("hidden");
      calculatorPacksQuantity.classList.remove("flex");
      calculatorHeaderButton.classList.add("active");
      packsHeaderButton.classList.remove("active");
      setCoverageVisibilityForTab(true);
    });

    packsHeaderButton.addEventListener("click", () => {
      calculatorCalculationContent.classList.add("hidden");
      calculatorPacksQuantity.classList.remove("hidden");
      calculatorPacksQuantity.classList.add("flex");
      packsHeaderButton.classList.add("active");
      calculatorHeaderButton.classList.remove("active");
      setCoverageVisibilityForTab(false);
      setTimeout(syncPacksTabTotals, 50);
    });
  }

  function clearCalculationInputs() {
    if (areaInput) areaInput.value = "";
    if (widthInput) widthInput.value = "";
    if (lengthInput) lengthInput.value = "";
    if (wastageCheckbox) wastageCheckbox.checked = false;
  }

  function resetPriceDisplay() {
    const isPacksTabActive = root
      .querySelector("#packs-header-button")
      ?.classList.contains("active");

    clearCalculationInputs();

    if (isPacksTabActive) {
      getQuantityInput()?.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    resetCalculatorResults();

    const quantityPicker = getQuantityInput();
    if (quantityPicker) {
      const min = parseInt(quantityPicker.getAttribute("min"), 10) || 1;
      quantityPicker.value = String(min);
      quantityPicker.setAttribute("value", String(min));
    }
  }

  function cleanup() {
    observer?.disconnect();
    clearTimeout(quantitySetupTimeout);
    window.ThemeBus?.removeEventListener(cartUpdatedEvent, resetPriceDisplay);
    window.removeEventListener("beforeunload", cleanup);
  }

  toggleInputFields();
  totalAreaRadio.addEventListener("change", toggleInputFields);
  widthLengthRadio.addEventListener("change", toggleInputFields);

  root.querySelectorAll('input[name="measurement-unit"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      const selected = root.querySelector("input[name='measurement-unit']:checked");
      if (!selected) return;
      currentUnit = selected.value;
      updateLabels();
      recalculate();
    });
  });

  const initialUnit = root.querySelector("input[name='measurement-unit']:checked");
  if (initialUnit) {
    currentUnit = initialUnit.value;
  }
  updateLabels();
  recalculate();

  widthInput?.addEventListener("input", onLengthWidthInput);
  lengthInput?.addEventListener("input", onLengthWidthInput);
  areaInput?.addEventListener("input", onAreaInput);
  wastageCheckbox?.addEventListener("change", recalculate);

  setupTabs();
  setupQuantitySelectorListeners();
  updatePriceFromQuantitySelector();

  try {
    observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === "childList")) {
        clearTimeout(quantitySetupTimeout);
        quantitySetupTimeout = setTimeout(setupQuantitySelectorListeners, 100);
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  } catch (error) {
    console.warn("MutationObserver setup failed:", error);
  }

  window.ThemeBus?.addEventListener(cartUpdatedEvent, resetPriceDisplay);
  window.addEventListener("beforeunload", cleanup);
})();
